import { createFileRoute } from "@tanstack/react-router";
import { ogImageMeta } from "@/lib/seo/og-image";
import { ServicePageTemplate } from "@/components/site/ServicePageTemplate";
import { getService } from "@/content/services";

import { pageSchemas } from "@/lib/seo/page-schema";
export const Route = createFileRoute("/media-monitoring/coverage")({
  head: () => ({
    meta: [
      { title: "Media Monitoring Coverage in Southeast Europe | Perceptica" },
      { name: "description", content: "See the sources Perceptica's media monitoring services cover - countries, languages, channels and outlets across Southeast Europe. Full coverage map inside." },
      { property: "og:title", content: "Media Monitoring Coverage in Southeast Europe | Perceptica" },
      { property: "og:description", content: "See the sources Perceptica's media monitoring services cover - countries, languages, channels and outlets across Southeast Europe. Full coverage map inside." },

      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "Media Monitoring Coverage in Southeast Europe | Perceptica" },
      { name: "twitter:description", content: "See the sources Perceptica's media monitoring services cover - countries, languages, channels and outlets across Southeast Europe. Full coverage map inside." },
      { property: "og:url", content: "https://perceptica.com/media-monitoring/coverage" },
      ...ogImageMeta("en", "/media-monitoring/coverage"),
      { property: "og:type", content: "website" },
    ],
  
    scripts: pageSchemas({ locale: "en", path: "/media-monitoring/coverage", service: { name: "Media monitoring services", description: "Perceptica media monitoring services for Southeast Europe.", serviceType: "Media monitoring services" } }),
  }),
  component: () => <ServicePageTemplate service={getService("coverage")} demoForm />,
});